import client from "../Client/HttpClient";
import { ISystemEvaluationMetricsModel } from "@/interfaces/modules";
const ApiPath = "SystemEvaluationMetrics";

export default {
    GetEvaluationMetrics: (): Promise<ISystemEvaluationMetricsModel[]> => client.get(`${ApiPath}`),
    GetEvaluationMetricById: (data: ISystemEvaluationMetricsModel): Promise<ISystemEvaluationMetricsModel> =>
        client.get(`${ApiPath}/${data.Id}`),
    PostEvaluationMetric: (data: ISystemEvaluationMetricsModel): Promise<ISystemEvaluationMetricsModel> =>
        client.post(`${ApiPath}`, data),
};
